import React from 'react';
import { connect } from 'react-redux';
import MediaQuery, { useMediaQuery } from 'react-responsive';
import clsx from 'clsx';
import { CssBaseline, AppBar, Toolbar, Button, Box, Divider, Grid, Autocomplete, TextField } from '@mui/material/';

import { IMAGES_URL } from '../../../constants/Images';

import { BasePageStyles } from '../../../hooks/styles';
import { PRODUCTS } from '../../../constants/Products';

import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useCart } from "react-use-cart";
import { useHistory } from 'react-router-dom';

const SearchAndCart = (props: any) => {
 //  const isDesktopOrLaptop = useMediaQuery({
 //    query: '(min-device-width: 900px)'
 //  })
const classes = BasePageStyles();
const products = PRODUCTS;
	const history = useHistory(); 

const routeChange = (path: string) =>{ 
		history.push(path);
	}

 const {
    isEmpty,
    totalUniqueItems,
    totalItems,
    items,
    updateItemQuantity,
    removeItem,
  } = useCart();

  return (
    <div>
    	<div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyItems: 'right'
          }}>
            <div style={{
              width: 300,
              paddingTop: 8,
              paddingLeft: 12
            }}>
              <Autocomplete
                  disablePortal
                  blurOnSelect
                  clearOnBlur
                  options={products}
                  getOptionLabel={(option: any) => `${option.name}`}
                  value={null}
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: 5
                  }}
                  onChange={(event, newValue) => {
                    if (newValue?.link) routeChange(newValue?.link)
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Find A Product"
                     

                    />
                  )}
                />
            </div>
            <div style={{
              width: 50,
              paddingTop: 8
            }}>
              <div onClick={() => routeChange('/cart')} style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                height: 50,
                marginLeft: 14,
                color: '#000'
              }}>
                <ShoppingCartIcon style={{
                  color: '#000'
                }} />
                ({totalItems})
              </div>
            </div>
        </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  // isLoading: state.ui.isLoading,
  // selectedTheme: 'light', //state.user.selectedTheme
  // dataIsPreloaded: state.ui.dataIsPreloaded
});

const mapDispatchToProps = (dispatch: any) => ({
  // setUrlFilter: (queryString: string) => { },
 
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchAndCart);

